import {Component, Input, Output, EventEmitter, ViewChild} from '@angular/core';


@Component({
	selector: 'ui-popup',
	host: {class: 'ui-popup'},
	template: `
		<div class="modal ui-modal {{!isHidden?'modal-is-shown':''}}" [hidden]="isHidden">
			<div class="modal-dialog " role="document">
				<div class="modal-content">
					<div class="modal-body">
						<span class="material-icons green float-left" *ngIf="type=='success'">done</span>
						<span class="material-icons red float-left" *ngIf="type=='danger'">error</span>
						<button class="btn btn-dark btn-sm float-right" (click)="isHidden = true;isHiddenChange.emit(true)"
						>{{okText}}
						</button>
						<div class="ui-popup-text">{{text}}</div>
					</div>
				</div>
			</div>
		</div>
	`
})
export class UIPopupComponent {
	@Input() type = 'success';
	@Input() text = '';
	@Input() okText = 'OK';

	@Input() isHidden = true;
	@Output() isHiddenChange = new EventEmitter();

}
